module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between my-3 bold"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_vm._v(_vm._s(_vm.groupNamesString))]), _vm._v(" "), _c('div', {
    staticClass: "fs-small color-1 pointer normal",
    on: {
      "click": _vm.toggleExpandInfo
    }
  }, [_vm._v(_vm._s(_vm.expanded ? 'hide details' : 'view details'))])]), _vm._v(" "), (_vm.expanded) ? _c('div', [(_vm.productDetailsHasChanges) ? _c('div', {
    staticClass: "fs-small bg-lighter p-2"
  }, _vm._l((_vm.product.changes.details), function(editedField) {
    return _c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.createNiceString(editedField.niceName, editedField.oldNiceValue, editedField.newNiceValue))
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.productSalesChannelsHasChanges) ? _c('div', {
    staticClass: "fs-small bg-lighter p-2"
  }, [_vm._l((_vm.product.changes.salesChannels), function(editedField) {
    return _c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.createNiceString(editedField.niceName, editedField.oldNiceValue, editedField.newNiceValue))
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.product.changes.agentSelected), function(editedField) {
    return _c('div', [(editedField.oldNiceValue != editedField.newNiceValue) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.createNiceString(editedField.niceName, editedField.oldNiceValue, editedField.newNiceValue))
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.product.changes.agentSelected.length !== 0 && _vm.product.changes.agentSelected[0].newNiceValue === 'Agent selection' /* && product.changes.salesChannels.length !== 0 && product.changes.salesChannels[0].newNiceValue != 'Closed' */ ) ? _c('span', [_vm._v("\n                Note that you have changes in "), _c('b', [_vm._v("Agent Selection")]), _vm._v(" items\n            ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.productHasAddedGroups) ? _c('div', {
    staticClass: "fs-small bg-lighter p-2"
  }, _vm._l((_vm.product.changes.addedGroups), function(editedField) {
    return _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v("Created group: \"" + _vm._s(editedField.newNiceValue) + "\"")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.productHasRemovedGroups) ? _c('div', {
    staticClass: "fs-small bg-lighter p-2"
  }, _vm._l((_vm.product.changes.removedGroups), function(editedField) {
    return _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v("Removed group: \"" + _vm._s(editedField.oldNiceValue) + "\"")])])
  }), 0) : _vm._e(), _vm._v(" "), _vm._l((_vm.product.groups), function(group) {
    return (_vm.product.groups.length > 0 && _vm.groupHasChanges(group)) ? _c('div', {
      staticClass: "fs-small bg-lighter p-2"
    }, [(group.id) ? _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(group.label) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "ml-3"
    }, [(_vm.groupAreaHasChanges(group)) ? _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v("Group:")]), _vm._v(" "), _vm._l((group.editedFields), function(editedField) {
      return _c('div', {
        staticClass: "ml-2"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.createNiceString(editedField.niceName, editedField.oldNiceValue, editedField.newNiceValue))
        }
      })])
    })], 2) : _vm._e(), _vm._v(" "), (_vm.schedulesAreaHasChanges(group)) ? _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v("Schedule:")]), _vm._v(" "), _vm._l((group.editedFieldsSchedules), function(editedField) {
      return _c('div', {
        staticClass: "ml-2"
      }, _vm._l((editedField.changes), function(changes) {
        return (changes.name != 'repeatsAtWeekDays') ? _c('div', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.createNiceString(changes.niceName, changes.oldNiceValue, changes.newNiceValue))
          }
        })]) : _vm._e()
      }), 0)
    }), _vm._v(" "), _vm._l((group.editedFieldsSchedulesRemoved), function(removedSchedule) {
      return (group.editedFieldsSchedulesRemoved) ? _c('div', [_c('span', {
        domProps: {
          "innerHTML": _vm._s('Removed schedule that started at: <b>' + removedSchedule.niceName + '</b>')
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group.editedFieldsSchedulesAdded), function(addedSchedule) {
      return (group.editedFieldsSchedulesAdded) ? _c('div', [_c('span', {
        domProps: {
          "innerHTML": _vm._s('Added new schedule that starts at: <b>' + addedSchedule.niceName + '</b>')
        }
      })]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (_vm.genderpricesAreaHasChanges(group)) ? _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v("Prices:")]), _vm._v(" "), _vm._l((group.editedFieldsGenderPrice), function(editedField) {
      return _c('div', {
        staticClass: "ml-2"
      }, [(editedField.genderPriceLabel) ? _c('div', {
        staticClass: "horizontalLineTitle bold"
      }, [_vm._v(_vm._s(editedField.genderPriceLabel))]) : _vm._e(), _vm._v(" "), _vm._l((editedField.changes), function(changes) {
        return _c('div', {
          staticClass: "ml-2"
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.createNiceString(changes.niceName, changes.oldNiceValue, changes.newNiceValue))
          }
        })])
      })], 2)
    }), _vm._v(" "), _vm._l((group.editedFieldsGenderPriceRemoved), function(removedGenderPrice) {
      return (group.editedFieldsGenderPriceRemoved) ? _c('div', {
        staticClass: "ml-2"
      }, [(removedGenderPrice.genderPriceLabel) ? _c('div', {
        staticClass: "horizontalLineTitle bold"
      }, [_vm._v(_vm._s(removedGenderPrice.genderPriceLabel))]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "ml-2",
        domProps: {
          "innerHTML": _vm._s('Removed price audience: <b>' + removedGenderPrice.niceName + '</b>')
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group.editedFieldsGenderPriceAdded), function(addedGenderPrice) {
      return (group.editedFieldsGenderPriceAdded) ? _c('div', {
        staticClass: "ml-2"
      }, [(addedGenderPrice.genderPriceLabel) ? _c('div', {
        staticClass: "horizontalLineTitle bold"
      }, [_vm._v(_vm._s(addedGenderPrice.genderPriceLabel))]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [_vm._v("\n                                Added new price audience: \n                                "), _c('b', [_vm._v(" \n                                    " + _vm._s(addedGenderPrice.niceName) + " \n                                    "), (addedGenderPrice.item.audienceTypeGroup != null || addedGenderPrice.item.audienceTypeGroup != undefined) ? _c('span', [_vm._v(" / ( Price Group Name: " + _vm._s(addedGenderPrice.item.audienceTypeGroup) + " )")]) : _vm._e()])])]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (_vm.genderPricesServicesHasChanges(group)) ? _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v("Prices:")]), _vm._v(" "), _vm._l((group.editedFieldsGenderPriceServices), function(editedField) {
      return _c('div', {
        staticClass: "ml-2"
      }, [(editedField.genderPriceLabel) ? _c('div', {
        staticClass: "horizontalLineTitle bold"
      }, [_vm._v(_vm._s(editedField.genderPriceLabel))]) : _vm._e(), _vm._v(" "), _vm._l((editedField.changes), function(changes) {
        return _c('div', {
          staticClass: "ml-2"
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.createNiceString(changes.niceName, changes.oldNiceValue, changes.newNiceValue))
          }
        })])
      })], 2)
    })], 2) : _vm._e(), _vm._v(" "), (_vm.rulesAreaHasChanges(group)) ? _c('div', [_c('div', {
      staticClass: "bold my-1"
    }, [_vm._v("Rules:")]), _vm._v(" "), _vm._l((group.editedFieldsPriceGroupsRemoved), function(removedPriceGroup) {
      return (group.editedFieldsPriceGroupsRemoved) ? _c('div', {
        staticClass: "ml-2"
      }, [_c('span', {
        staticClass: "ml-2",
        domProps: {
          "innerHTML": _vm._s('Removed rule group: <b>' + removedPriceGroup.niceName + '</b>')
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group.editedFieldsPriceGroupsAdded), function(addedPriceGroup) {
      return (group.editedFieldsPriceGroupsAdded) ? _c('div', {
        staticClass: "ml-2"
      }, [_c('span', {
        staticClass: "ml-2",
        domProps: {
          "innerHTML": _vm._s('Added rule group: <b>' + addedPriceGroup.niceName + '</b>')
        }
      })]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (_vm.priceDependenciesHasChanges(group)) ? _c('div', [_c('div', {
      staticClass: "bold my-1"
    }, [_vm._v("Prices Dependencies:")]), _vm._v(" "), _vm._l((group.editedFieldsPriceDependencies), function(deps) {
      return _c('div', [_c('div', {
        staticClass: "horizontalLineTitle bold"
      }, [_vm._v(_vm._s(deps.genderPriceLabel))]), _vm._v(" "), _vm._l((deps.infoToShow), function(information) {
        return _c('div', [(information.type === 'add') ? _c('div', {
          staticClass: "ml-2"
        }, [_c('span', {
          staticClass: "ml-2",
          domProps: {
            "innerHTML": _vm._s(("Added category dependency: <b>" + (information.info) + "</b>"))
          }
        })]) : _vm._e(), _vm._v(" "), (information.type === 'remove') ? _c('div', {
          staticClass: "ml-2"
        }, [_c('span', {
          staticClass: "ml-2",
          domProps: {
            "innerHTML": _vm._s(("Removed category dependency: <b>" + (information.info) + "</b>"))
          }
        })]) : _vm._e(), _vm._v(" "), (information.type === 'type') ? _c('div', {
          staticClass: "ml-2"
        }, [(information.info.old !== null) ? _c('span', {
          staticClass: "ml-2",
          domProps: {
            "innerHTML": _vm._s(("Changed dependency type from <b>" + (information.info.old) + "</b> to <b>" + (information.info.new) + "</b>"))
          }
        }) : _c('span', {
          staticClass: "ml-2",
          domProps: {
            "innerHTML": _vm._s(("New dependency type: <b>" + (information.info.new) + "</b>"))
          }
        })]) : _vm._e(), _vm._v(" "), (information.type === 'quantity') ? _c('div', {
          staticClass: "ml-2"
        }, [_c('span', {
          staticClass: "ml-2",
          domProps: {
            "innerHTML": _vm._s(("<b>" + (information.info.label) + "</b> quantity changed from <b>" + (information.info.oldQuantity) + "</b> to <b>" + (information.info.newQuantity) + "</b>"))
          }
        })]) : _vm._e()])
      })], 2)
    })], 2) : _vm._e(), _vm._v(" "), (_vm.resourcesAreaHasChanges(group)) ? _c('div', [_c('div', {
      staticClass: "bold"
    }, [_vm._v("Resources:")]), _vm._v(" "), _vm._l((group.editedFieldsResources), function(editedField) {
      return _c('div', {
        staticClass: "ml-2"
      }, _vm._l((editedField.changes), function(changes) {
        return _c('div', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.createNiceString(changes.niceName, changes.oldNiceValue, changes.newNiceValue))
          }
        })])
      }), 0)
    }), _vm._v(" "), _vm._l((group.editedFieldsResourcesRemoved), function(removedResource) {
      return (group.editedFieldsResourcesRemoved) ? _c('div', [_c('span', {
        domProps: {
          "innerHTML": _vm._s('Removed resource: <b>' + removedResource.niceName + '</b>')
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group.editedFieldsResourcesAdded), function(addedResource) {
      return (group.editedFieldsResourcesAdded) ? _c('div', [_c('span', {
        domProps: {
          "innerHTML": _vm._s('Added new resource: <b>' + addedResource.niceName + '</b>')
        }
      })]) : _vm._e()
    })], 2) : _vm._e()])]) : _vm._e()]) : _vm._e()
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-865445dc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/scheduleGroupChanges.vue
// module id = 1456
// module chunks = 0